// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --reseller-trends-padding-description-top: 18px;
  --reseller-trends-padding-item-y: 25px;
  --reseller-trends-margin-bottom-head: 7px;
  --reseller-trends-svg-height: 391px;
  --reseller-trends-svg-width: 429px;
  --reseller-trends-highlighed-item-border-width: 8px;
}

.reseller-trends-slide {
  width: 925px;
}

.reseller-trends-slide-image {
  height: var(--reseller-trends-svg-height);
  width: var(--reseller-trends-svg-width);
}

.reseller-trends-slide-description {
  padding-top: var(--reseller-trends-padding-description-top);
  text-overflow: initial;
  white-space: normal;
  width: 432px;
}

.reseller-trends-slide-header {
  margin-bottom: var(--reseller-trends-margin-bottom-head);
}

.reseller-trends-slide-item {
  padding-top: var(--reseller-trends-padding-item-y);
  padding-bottom: var(--reseller-trends-padding-item-y);
}

.reseller-trends-slide-item--highlighted {
  border-left-width: var(--reseller-trends-highlighed-item-border-width);
  border-left-style: solid;
}`, "",{"version":3,"sources":["webpack://./src/components/slides/reseller-trends-slide/ResellerTrendsSlide.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,2DAA2D;EAC3D,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,sEAAsE;EACtE,wBAAwB;AAC1B","sourcesContent":[":root {\n  --reseller-trends-padding-description-top: 18px;\n  --reseller-trends-padding-item-y: 25px;\n  --reseller-trends-margin-bottom-head: 7px;\n  --reseller-trends-svg-height: 391px;\n  --reseller-trends-svg-width: 429px;\n  --reseller-trends-highlighed-item-border-width: 8px;\n}\n\n.reseller-trends-slide {\n  width: 925px;\n}\n\n.reseller-trends-slide-image {\n  height: var(--reseller-trends-svg-height);\n  width: var(--reseller-trends-svg-width);\n}\n\n.reseller-trends-slide-description {\n  padding-top: var(--reseller-trends-padding-description-top);\n  text-overflow: initial;\n  white-space: normal;\n  width: 432px;\n}\n\n.reseller-trends-slide-header {\n  margin-bottom: var(--reseller-trends-margin-bottom-head);\n}\n\n.reseller-trends-slide-item {\n  padding-top: var(--reseller-trends-padding-item-y);\n  padding-bottom: var(--reseller-trends-padding-item-y);\n}\n\n.reseller-trends-slide-item--highlighted {\n  border-left-width: var(--reseller-trends-highlighed-item-border-width);\n  border-left-style: solid;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
